<!--
  - Copyright (c) 2023. Henry Zilek
  -->

<template>
  <section class="hz-button">
    <HZLink :to="target" >
      <button class="hz-button-text">
        <span class="icon"> <slot name="icon"/></span>
        <span class="font-style-base"><slot/>
        </span>
      </button>
    </HZLink>
  </section>
</template>

<script>
export default {
  name: "HZBaseButton",
  props: {
    target: {
      type: [String, Object],
      default: () => {
        return {name: "Home", text: "Home", hash: "#uvod"}
      }
    },

  },

  methods: {}

}
</script>

<style scoped>
.icon {
  padding: 0 10px 0 0;
  display: inline-block;
}

.icon:empty {
  display: none;
}

.hz-button-text{
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-items: center;
}
</style>